import React from "react"
import type { ListarProdutosModel } from "../models/listarProdutosModel"
import { ListarProdutosInicial } from "../models/listarProdutosModel"
import type { ListarProdutosAction } from "./listarProdutosActions"
import type { FiltroMaisVendidos } from "../../../services/listarProdutos"

export type ListarProdutosContextValue = {
    dados: ListarProdutosModel
    dispatch: React.Dispatch<ListarProdutosAction>
    erroCarregamento: string | null
    pesquisar: (filtro: FiltroMaisVendidos) => Promise<void>
}

export const ListarProdutosContext = React.createContext<ListarProdutosContextValue>({
    dados: ListarProdutosInicial,
    dispatch: () => {},
    erroCarregamento: null,
    pesquisar: async () => {},
})
